import { connect } from 'react-redux';
import _ from 'lodash';
import { toggleModal } from 'state/callers';
import WrappedModal from './Modal';

const mapStateToProps = state => {
  const stateMapper = _.get(state, 'modalState.stateMapper', () => null);

  return {
    state: stateMapper(state),
    ...state.modalState
  };
};

const mapDispatchToProps = {
  toggleModal
};

export default connect(mapStateToProps, mapDispatchToProps)(WrappedModal);
